import { connect } from 'react-redux';
import { Button, List, Popup } from 'semantic-ui-react';
import * as actions from '../../redux/actions';
import { bindActionCreators } from 'redux';

export const EditOrganizationFirms = ({ organization, removeFirmFromOrganization }) => {
  const getPage = () => (
    <List selection verticalAlign="middle" divided>
      {organization.showcaseFirms.map(firm => (
        <List.Item key={firm.id}>
          <Popup
            trigger={
              <List.Content>
                <List.Icon name="building outline" />
                {firm.name}
              </List.Content>
            }
            on="click"
            position="bottom left"
            size="tiny"
          >
            <Button
              size="mini"
              color="red"
              icon="trash"
              content="Remove Role"
              fluid
              onClick={() => removeFirmFromOrganization(firm.id)}
            />
          </Popup>
        </List.Item>
      ))}
    </List>
  );

  return <>{organization && organization.id && getPage()}</>;
};

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({
  updateGroup: bindActionCreators(actions.admin.updateUserGroup, dispatch),
  removeFirmFromOrganization: bindActionCreators(actions.firm.removeFirmFromOrganization, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditOrganizationFirms);
